import {
  ICreateRoomParams,
  IURLIdParams,
  INearByRoomsParams, IRoomStatusParams,
  IRoomTokenParams,
  IRoomNotiEmailParams
} from 'modules/params/param.type';
import { apiCall } from 'store/services/service';
import {
  URL_CREATE_ROOM,
  URL_ROOM_LIST,
  URL_JOIN_ROOM,
  URL_ROOMS_NEARBY,
  URL_ROOM_STATUS,
  URL_ROOM_DELETE,
  URL_ROOM_INTRO_VIDEO,
  URL_ROOM_TOKEN,
  URL_NOTIFICATION_EMAIL,
  URL_MEETING_NOTIFICATION_EMAIL,
  URL_SEND_JOIN_REQUEST,
  URL_GET_LOCATION
} from 'store/services/URL';

export const api = {
  createRoomRequest(params: ICreateRoomParams) {
    return apiCall.post({ url: URL_CREATE_ROOM, isAuthToken: true, params });
  },
  getRoomRequest() {
    return apiCall.get({ url: URL_CREATE_ROOM, isAuthToken: true, params: {} });
  },
  joinRoomRequest(params: IURLIdParams) {
    return apiCall.postURLWithId({ url: URL_JOIN_ROOM, isAuthToken: true, params: params });
  },
  getAllRoomsRequest() {
    return apiCall.get({ url: URL_ROOM_LIST, isAuthToken: true, params: {} });
  },
  nearByRoomsRequest(params: INearByRoomsParams) {
    return apiCall.post({ url: URL_ROOMS_NEARBY, isAuthToken: true, params: params });
  },
  roomStatusRequest(params: IRoomStatusParams) {
    return apiCall.postURLAndBody({ url: URL_ROOM_STATUS, isAuthToken: true, params: params });
  },
  roomDeleteRequest(params: { id: string }) {
    return apiCall.post({ url: `${URL_ROOM_DELETE}${params.id}/delete`, isAuthToken: true, params: {} });
  },
  updateRoomIntroVideo(params: { id: string; intro_video_url: string | null }) {
    return apiCall.patch({ url: `${URL_ROOM_INTRO_VIDEO}${params.id}/intro-video`, isAuthToken: true, params: { intro_video_url: params.intro_video_url } });
  },
  getRoomToken(params: IRoomTokenParams) {
    return apiCall.post({ url: URL_ROOM_TOKEN, isAuthToken: true, params: params });
  },
  sendNotificationEmail(params: IRoomNotiEmailParams) {
    return apiCall.post({url: URL_NOTIFICATION_EMAIL, isAuthToken: true, params: params });
  },
  sendMeetingNotificationEmail(params: IRoomNotiEmailParams) {
    return apiCall.post({url: URL_MEETING_NOTIFICATION_EMAIL, isAuthToken: true, params: params });
  },
  sendJoinRequestEmail(params: {room_id: string}) {
    return apiCall.post({url: URL_SEND_JOIN_REQUEST, isAuthToken: true, params: params });
  },
  getLocationFromCoordinates(params: {latitude: string, longitude: string}) {
    return apiCall.post({ url: URL_GET_LOCATION, isAuthToken: true, params });
  }
};

export default api;
